import request from "../utils/request";

export const getBrands = '/brand/'

export function modifyBrand(data: any) {
    return request.request({
        url: '/brand/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteBrand(id: number) {
    return request.request({
        url: '/brand/',
        method: 'delete',
        params: {brandId: id}
    })
}
